module.exports = __webpack_public_path__ + "static/media/SPO-125.9e1bc08c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/SPO-125.jpg
// module id = 157
// module chunks = 0